import { shortUserFromDto } from '@src/features/users/lib/user';

import type {
  ClientDeactivation,
  ClientDeactivationDto,
  ClientDetail,
  ClientDetailDto,
  ClientFilterOptions,
  ClientFilterOptionsDto,
  ClientGroupListItem,
  ClientGroupListItemDto,
  ClientListItem,
  ClientListItemDto,
  ClientOption,
  ClientOptionDto,
} from '../types';

export function clientListItemFromDto(
  client: ClientListItemDto,
): ClientListItem {
  return {
    id: client.id,
    name: client.name,
    legalName: client.legal_name,
    businessSegment: client.business_segment,
    active: client.active,
    isHeadquarter: client.is_headquarter,
    sector: client.sector,
    seat: client.seat,
    manager: shortUserFromDto(client.manager),
    coordinator: shortUserFromDto(client.coordinator),
    revenue: client.revenue,
    budget: client.budget,
    margin: client.margin,
  };
}

export function clientGroupListItemFromDto(
  group: ClientGroupListItemDto,
): ClientGroupListItem {
  return {
    id: group.id,
    name: group.name,
    logo: group.logo,
    businessSegments: group.business_segments,
    active: group.active,
    warnings: group.warnings,
    sector: group.sector,
    seat: group.seat,
    managers: group.managers.map(shortUserFromDto),
    coordinators: group.coordinators.map(shortUserFromDto),
    revenue: group.revenue,
    budget: group.budget,
    margin: group.margin,
    clients: group.clients.map(clientListItemFromDto),
  };
}

export function clientFilterOptionsFromDto(
  data: ClientFilterOptionsDto,
): ClientFilterOptions {
  return {
    seatCities: data.seat_cities,
    seatCountries: data.seat_countries,
    managers: data.managers,
    coordinators: data.coordinators,
  };
}

export function clientDetailFromDto(client: ClientDetailDto): ClientDetail {
  return {
    id: client.id,
    version: client.version,
    name: client.clie_name,
    legalName: client.clie_legalname,
    businessSegment: client.clie_business_segment,
    active: client.clie_active,
    companyRegistryNumber: client.clie_company_registry_number,
    vatNumber: client.clie_vat_number,
    estimatedRevenuePotential: client.clie_estimated_revenue_potential,
    website: client.clie_website,
    phone: client.clie_phone,
    notes: client.clie_notes,
    verificationDate: client.clie_verification_date,
    group: client.group,
    sector: client.sector,
    relationshipStatus: client.relationship_status,
    manager: shortUserFromDto(client.manager),
    coordinator: shortUserFromDto(client.coordinator),
    verifiedBy: shortUserFromDto(client.verified_by),
    location: client.location,
    isHeadquarter: client.is_headquarter,
    revenueCurrentYear: client.revenue_current_year,
    revenuePreviousYear: client.revenue_previous_year,
    budgetFulfilment: client.budget_fulfilment,
    canEdit: client.can_edit,
  };
}

export function clientOptionFromDto(client: ClientOptionDto): ClientOption {
  return {
    id: client.id,
    name: client.name,
    legalName: client.legal_name,
    businessSegment: client.business_segment,
    active: client.active,
    group: client.group,
  };
}

export function clientDeactivationFromDto(
  data: ClientDeactivationDto,
): ClientDeactivation {
  return {
    isHeadquarter: data.is_headquarter,
    clients: data.clients.map(clientOptionFromDto),
    refusal: data.refusal,
  };
}
